import { render, staticRenderFns } from "./SaleCount.vue?vue&type=template&id=12705808&scoped=true&"
import script from "./SaleCount.vue?vue&type=script&lang=js&"
export * from "./SaleCount.vue?vue&type=script&lang=js&"
import style0 from "./SaleCount.vue?vue&type=style&index=0&id=12705808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12705808",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VCol,VRow,VSkeletonLoader,VTooltip})
